import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
function ExplorerFilterTypeFloat(parent) {
    var self = this;
    self.ObjectValueFrom = ko.observable();
    self.ObjectValueTo = ko.observable();
    self.ExplorerFilterOperatorFromId = ko.observable();
    self.ExplorerFilterOperatorToId = ko.observable();
    self.Caption = ko.observable();
    self.TextEnabledFrom = ko.observable(true);
    self.TextEnabledTo = ko.observable(true);
    self.Focus = function () { };
    self.Save = function () {
        return Bao.post("ExplorerFilter/SaveExplorerFilterDefinitionFloat", JSON.stringify({
            objectValueFrom: self.ObjectValueFrom(),
            objectValueTo: self.ObjectValueTo(),
            explorerFilterOperatorFromId: self.ExplorerFilterOperatorFromId(),
            explorerFilterOperatorToId: self.ExplorerFilterOperatorToId(),
            explorerFilterDefinitionId: parent.SelectedExplorerFilterDefinitionId(),
            sessionTabId: parent.TabPage.SessionTabId
        }), function (result) { });
    };
    self.loaded = function () {
        if (parent != null && parent.ExplorerFilterDefinitionDataSource() != null) {
            var dataSource = parent.ExplorerFilterDefinitionDataSource();
            self.Caption(dataSource.Caption);
            self.ObjectValueFrom(dataSource.ObjectValueFrom);
            self.ObjectValueTo(dataSource.ObjectValueTo);
            self.ExplorerFilterOperatorFromId(dataSource.ExplorerFilterOperatorFromId);
            self.ExplorerFilterOperatorToId(dataSource.ExplorerFilterOperatorToId);
        }
        self.Focus();
        self.ObjectValueFrom.subscribe(function () {
            self.Save();
        });
        self.ObjectValueTo.subscribe(function () {
            self.Save();
        });
        self.ExplorerFilterOperatorFromId.subscribe(function (newValue) {
            if (null == newValue || "" == newValue) {
                self.ObjectValueFrom("");
                self.ObjectValueTo("");
                self.ExplorerFilterOperatorToId(null);
                self.TextEnabledFrom(false);
                self.TextEnabledTo(false);
            }
            else {
                self.TextEnabledFrom(true);
                self.TextEnabledTo(true);
            }
            self.Save();
        });
        self.ExplorerFilterOperatorToId.subscribe(function (newValue) {
            if (null == newValue || "" == newValue) {
                self.ObjectValueTo("");
                self.TextEnabledTo(false);
            }
            else {
                self.TextEnabledTo(true);
            }
            self.Save();
        });
    };
}
export default ExplorerFilterTypeFloat;